import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'VR',
    name: 'Valeria R.',
    loc: '📍 Buenos Aires | Docente de 5.º Grado',
    quote: 'Compré el MegaPack un domingo a la noche. El lunes tenía todo el año de Sociales organizado. Los solucionarios me cambiaron la vida: ya no corrijo en blanco, tengo los criterios listos para justificar cada nota. La directora me felicitó por la planificación sin saber que la hice en 20 minutos.'
  }, {
    initials: 'SL',
    name: 'Silvia L.',
    loc: '📍 Córdoba | Maestra de 4.º Grado Primaria',
    quote: 'Lo que más me impactó fue el material de Pueblos Originarios. Siempre me daba miedo abordarlo mal y que algún padre se quejara. El Bono 6 me explicó exactamente cómo hacerlo con respeto y sin conflictos. Las actividades son hermosas y los chicos quedaron enganchados toda la semana.'
  }, {
    initials: 'PM',
    name: 'Patricia M.',
    loc: '📍 Rosario | Docente de 3.º Grado',
    quote: 'El Pack de Efemérides me salvó el año. Siempre me agarraba el 25 de Mayo sin preparar nada. Ahora tengo guiones, palabras alusivas y actividades listas para imprimir. Tardé 10 minutos en preparar el mejor acto que hice en 8 años de carrera.'
  }, {
    initials: 'MG',
    name: 'Marcela G.',
    loc: '📍 Mendoza | Docente de 6.º Grado Primaria',
    quote: 'Doy 6.º grado y el tomo de Argentina contemporánea es increíble. El material sobre dictadura, democracia y derechos humanos está pensado para chicos de esa edad: no es ni demasiado duro ni demasiado suavizado. Mis alumnos salieron del año sabiendo de verdad qué es el Nunca Más.'
  }, {
    initials: 'FM',
    name: 'Fernanda M.',
    loc: '📍 Tucumán | Maestra de 2.º Grado',
    quote: 'Tengo plurigrado: doy 2.º y 3.º al mismo tiempo. El MegaPack me permitió tener material diferenciado para cada grupo sin volverme loca. El Bono de Preguntas Activadoras es perfecto porque puedo arrancar la clase con todos juntos y luego separarlos por nivel.'
  }, {
    initials: 'AT',
    name: 'Adriana T.',
    loc: '📍 Santa Fe | Docente de 1.º Grado',
    quote: 'Pensé que para 1.º grado no iba a servir mucho porque los chicos no saben leer bien. Pero las actividades están perfectamente diseñadas para la etapa de alfabetización: dibujos, recortables, líneas para completar con ayuda. Los chicos aman el material y yo amo no tener que diseñarlo.'
  }];
  return <section className="bg-brand-dark py-32 px-4 border-t border-brand-border" data-id="element-258">
      <div className="max-w-6xl mx-auto" data-id="element-259">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-20 max-w-4xl mx-auto leading-tight" data-id="element-260">
          LO QUE DICEN LOS DOCENTES QUE YA TIENEN SU{' '}
          <span className="text-brand-accent" data-id="element-261">MEGAPACK:</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-262">
          {testimonials.map((test, i) => <div key={i} className="bg-brand-card rounded-3xl p-10 border border-brand-border" data-id="element-263">
              <div className="flex items-center gap-5 mb-8" data-id="element-264">
                <div className="w-16 h-16 rounded-full bg-brand-accent/10 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-2xl flex-shrink-0" aria-hidden="true" data-id="element-265">
                  {test.initials}
                </div>
                <div data-id="element-266">
                  <div className="text-brand-accent mb-2 text-sm" aria-label="5 estrellas" data-id="element-267">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="font-bold text-white text-xl mb-1" data-id="element-268">
                    {test.name}
                  </p>
                  <p className="text-sm text-white/70 font-medium" data-id="element-269">
                    {test.loc}
                  </p>
                </div>
              </div>
              <blockquote className="text-white/80 italic leading-relaxed text-lg" data-id="element-270">
                "{test.quote}"
              </blockquote>
            </div>)}
        </div>
      </div>
    </section>;
}